import { useCallback, useState } from 'react';

// Pass the ref object to the component you want to get the refFrom <Blah ref={ref} />
// When the ref initializes it will call this function to set both the node and the inital height.
export const useRefHeight = () => {
	const [initialHeight, setInitialHeight] = useState();
	const [node, setNode] = useState<HTMLElement | undefined>();

	const ref = useCallback((node: any) => {
		if (node !== null) {
			setInitialHeight(node.clientHeight);
			setNode(node);
		}
	}, []);

	return {
		initialHeight,
		height: node?.clientHeight ?? 0,
		ref,
	};
};
